export const formatDocumentNumber = (documentNumber?: string) =>
  documentNumber && `#${documentNumber}`
